module.exports = __webpack_public_path__ + "static/media/beach.c2420e6a.png";